import Login from '@/pages/Login'

export default {
  path: '',
  component: Login,
  children: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/login/activate/:activatetoken',
      name: 'ActivateToken',
      component: Login,
    },
    {
      path: '/login/resetpassword/:token',
      name: 'ResetPassword',
      component: Login,
    },
  ]
  // path: '/login',
  // name: 'login',
  // component: Login
}



// WEBPACK FOOTER //
// ./src/router/login.js